import React, { FC } from 'react'
import { Button } from '@mui/material'

type ResetTableFilterProps = {
  stateFilters: unknown[]
  onResetFilters: () => void
}

export const ButtonResetTableFilters: FC<ResetTableFilterProps> = ({
  stateFilters,
  onResetFilters,
}): React.ReactElement | null => {
  const canReset = stateFilters.some((state) => !!state)

  return (
    <Button color="secondary" onClick={onResetFilters} size="large" disabled={!canReset} fullWidth>
      Сбросить всё
    </Button>
  )
}
